export default {
  // Business
  email: null,
  phoneNumber: null,
  MFA: false,
  businessName: null,
  address: null,
  addressTwo: null,
  city: null,
  state: null,
  zip: null,
  businessPhone: null,
  website: null,
  companyInfo: null,
  companyInfoTwo: null,
  areasServiced: [],
  alteredForms: [],
  serviceAreaCoords: [],
  adminFirstName: null,
  adminLastName: null,
  adminEmail: null,
  adminPhone: null,
  qcFirstName: null,
  qcLastName: null,
  qcEmail: null,
  qcPhone: null,
  csFirstName: null,
  csLastName: null,
  csEmail: null,
  csPhone: null,
  salesEmail: null,
  displayName: null,
  salesPhoneNumber: null,
  insuranceAmount: 0,
  licenseNumber: null,
  costLevel: null,
  availabilityLevel: null,
  times: {
    monday: {
      open: null,
      closed: null
    },
    tuesday: {
      open: null,
      closed: null
    },
    wednesday: {
      open: null,
      closed: null
    },
    thursday: {
      open: null,
      closed: null
    },
    friday: {
      open: null,
      closed: null
    },
    saturday: {
      open: null,
      closed: null
    },
    sunday: {
      open: null,
      closed: null
    }
  },
  emergencies: null,
  selectedServices: [],
  images: [],
  profileImage: null,
  userType: null,
  cognitoId: null,
  idProvider: null,
  accessKeyId: null,
  secretAccessKey: null,
  sessionToken: null,
  expireTime: null,
  bannerImage: null,
  ssn: null,
  languagesSpoken: null,
  yearEstablished: null,
  serviceType: [],
  hideAddress: false,
  allowSendTexts: false,
  enableQuoteRequest: true,
  hideYears: false,
  businessId: null,
  couponPaymentOverdue: null,
  paymentFailureNotification: null,
  // User
  userLegalFirstName: null,
  userLastName: null,
  userEmail: null,
  userCellPhone: null,
  userStreet1: null,
  userStreet2: null,
  userCity: null,
  userState: null,
  userZipCode: null,
  userImages: [],
  userProfileImage: null,
  userCouponAlerts: [],
  userPromotionAlerts: [],
  userSavedBusinesses: [],
  userSavedHouses: [],
  userClaimedHouses: [],
  userMyLenderCode: null,
  userMyRealtorCode: null,
  userMyServiceProviderId: null,
  blockList: [],
  notificationNumber: 0,
  // Lender
  lenderBranchLink: null,
  lenderBranchQRCode: null,
  lenderBrokerageName: null,
  lenderBrokeragePicture: null,
  lenderLicenseNumber: null,
  lenderPhoneNumber: null,
  lenderProfilePicture: null,
  lenderCode: null,
  lenderCognitoId: null,
  lenderBackgroundColor: '#000000',
  lenderEmail: null,
  lenderName: null,
  lenderPaymentHistory: [],
  lenderTextColor: '#000000',
  lenderSubscriptionId: null,
  lenderSubscriptionPrice: 0,
  lenderSubscriptionDiscountAmount: 0,
  lenderSubscriptionDiscountExpirationDate: null,
  lenderSubscriptionStartDate: null,
  lenderSubscriptionEndDate: null,
  lenderSubscriptionNextBillingDate: null,
  lenderSubscriptionRenewal: false,
  lenderSubscriptionCreditCardType: null,
  lenderSubscriptionCreditCardLastFour: null,
  lenderSubscriptionCustomFlag: false,
  lenderClientIds: [],
  lenderBraintreeCustomerId: null,
  lenderPremium: false,
  // Realtor
  realtorBranchLink: null,
  realtorBranchQRCode: null,
  realtorBrokerageName: null,
  realtorBrokeragePicture: null,
  realtorLicenseNumber: null,
  realtorPhoneNumber: null,
  realtorProfilePicture: null,
  realtorCode: null,
  realtorCognitoId: null,
  realtorBackgroundColor: '#000000',
  realtorEmail: null,
  realtorName: null,
  realtorPaymentHistory: [],
  realtorTextColor: '#000000',
  realtorSubscriptionId: null,
  realtorSubscriptionPrice: 0,
  realtorSubscriptionDiscountAmount: 0,
  realtorSubscriptionDiscountExpirationDate: null,
  realtorSubscriptionStartDate: null,
  realtorSubscriptionEndDate: null,
  realtorSubscriptionNextBillingDate: null,
  realtorSubscriptionRenewal: false,
  realtorSubscriptionCreditCardType: null,
  realtorSubscriptionCreditCardLastFour: null,
  realtorSubscriptionCustomFlag: false,
  realtorClientIds: [],
  realtorBraintreeCustomerId: null,
  realtorPremium: false,
  // Service Provider Company
  serviceProviderCompanyAddress: null,
  serviceProviderCompanyCallPhoneNumber: null,
  serviceProviderCompanyCategory: null,
  serviceProviderCompanyCouponText: null,
  serviceProviderCompanyDetails: null,
  serviceProviderCompanyEmail: null,
  serviceProviderCompanyId: null,
  serviceProviderCompanyLatitude: null,
  serviceProviderCompanyLogo: null,
  serviceProviderCompanyLongitude: null,
  serviceProviderCompanyName: null,
  serviceProviderCompanyOwnerId: null,
  serviceProviderCompanyPaymentHistory: [],
  serviceProviderCompanyPreferredCommunication: [],
  serviceProviderCompanyPremium: false,
  serviceProviderCompanyReferralText: null,
  serviceProviderCompanySubscriptionId: null,
  serviceProviderCompanySubscriptionPrice: 0,
  serviceProviderCompanySubscriptionDiscountAmount: 0,
  serviceProviderCompanySubscriptionDiscountExpirationDate: null,
  serviceProviderCompanySubscriptionStartDate: null,
  serviceProviderCompanySubscriptionEndDate: null,
  serviceProviderCompanySubscriptionNextBillingDate: null,
  serviceProviderCompanySubscriptionRenewal: false,
  serviceProviderCompanySubscriptionCreditCardType: null,
  serviceProviderCompanySubscriptionCreditCardLastFour: null,
  serviceProviderCompanySubscriptionCustomFlag: false,
  serviceProviderCompanyTextPhoneNumber: null,
  // Priority Plan
  currentPlanName: null,
  currentPlanPrice: null,
  currentPlanZipCodes: [],
  planBillingPeriodEndDate: null,
  planBillingPeriodStartDate: null,
  planNextBillingDate: null,
  priorityPlanStatus: true,
  product: null,
  zipCodes: [],
  // Coupons
  couponBudget: 0,
  couponBudgetedClicks: 0,
  couponCategory: null,
  couponCombosAllowed: null,
  couponCustomerReuses: null,
  couponDefaultResponse: null,
  couponDetails: null,
  couponDiscountedPrice: 0,
  couponExpiration: null,
  couponFreeClicks: 0,
  couponId: null,
  couponListPrice: 0,
  couponName: null,
  couponPromotionalCode: null,
  couponStatus: true,
  specialties: [],
  hasAdvertisingPlan: false,
  // homeSearch
  propertyType: ['Townhouse', 'House', 'Land', 'Condo', 'Multi-Family'],
  bathNumber: 'Any',
  bedNumber: 'Any',
  listingStatus: ['Active'],
  listingOptions: [],
  listingEvents: [],
  minSqft: null,
  maxSqft: null,
  minLotSize: null,
  maxLotSize: null,
  minPrice: 0,
  maxPrice: 0,
  maxHOA: 0,
  minHOA: 0,
  insideFeatures: [],
  outsideFeatures: [],
  heatingCooling: [],
  garage: 'Any',
  parking: [],
  minHomeAge: null,
  maxHomeAge: null,
  lotView: [],
  communityAmenities: [],
  stories: 'Any',
  lastNonEmptyQuery: [],
  showWindow: false,
  // marketSearch
  marketRating: [],
  marketPrice: [],
  marketAvailability: [],
  marketMore: [],
  // loginModal
  loginMode: true,
  // Property
  propertyUniqueId: null,
  propertyEstimatesAllowed: false,
  propertyCommentsAllowed: false,
  propertyListType: null,
  propertySpecialCircumstances: null,
  propertyBrokerage: null,
  propertyMlsId: null,
  propertyParcelId: [],
  propertyLatitude: null,
  propertyLongitude: null,
  propertyGeoPoint: null,
  propertyExpectedMarketDate: null,
  propertyDownloadTime: null,
  propertyStatus: null,
  propertyContingency: null,
  propertyPrice: null,
  propertyBedroomCount: null,
  propertyBathroomCount: null,
  propertyLotAcres: null,
  propertyLotSqft: null,
  propertyHouseSqft: null,
  propertyYearBuilt: null,
  propertyFoundationSize: null,
  propertyStories: null,
  propertyStyle: null,
  propertyManufacturedHome: null,
  propertyAvailableStarting: null,
  propertyApplicationFee: null,
  propertyRequiredBackgroundCheck: null,
  propertyMinLeaseMonths: null,
  propertySmokingPermitted: null,
  propertyLaundryAvailability: null,
  propertyOwnerPays: [],
  propertyTenantPays: [],
  propertySecurityDeposit: null,
  propertyFees: [],
  propertyPrepaidRent: null,
  propertyNewConstruction: null,
  propertyBuilderName: null,
  propertyProjectedCompletionDate: null,
  propertyModelLocation: null,
  propertyModelHours: null,
  propertyLowPriceRange: null,
  propertyHighPriceRange: null,
  propertySoldDate: null,
  propertySoldPrice: null,
  propertyUnitNumber: null,
  propertyStreetNumber: null,
  propertyStreetDir: null,
  propertyStreetName: null,
  propertyStreetSuffix: null,
  propertyNeighborhood: null,
  propertyCity: null,
  propertyCounty: null,
  propertyState: null,
  propertyZipCode: null,
  propertyBedrooms: [],
  propertyBathrooms: [],
  propertyBathroomDescription: [],
  propertyFullBaths: null,
  propertyThreeQuarterBaths: null,
  propertyHalfBaths: null,
  propertyQuarterBaths: null,
  propertyKitchen: null,
  propertyDiningRoom: null,
  propertyDiningDescription: [],
  propertyLivingRoom: null,
  propertyFamilyRoom: null,
  propertyOtherRooms: [],
  propertyBasement: [],
  propertyFurnished: null,
  propertyHeating: [],
  propertyFuel: [],
  propertyFireplaces: [],
  propertyFireplaceCount: null,
  propertyCooling: [],
  propertyWater: [],
  propertySewer: [],
  propertyAppliances: [],
  propertyOutbuildings: [],
  propertyFrontage: [],
  propertyGarageStalls: null,
  propertyOtherStalls: null,
  propertyGarageDimensions: null,
  propertyGarageDoorHeight: null,
  propertyGarageDoorWidth: null,
  propertyGarage: [],
  propertyDriveway: [],
  propertyRoof: [],
  propertyExterior: [],
  propertyFence: [],
  propertyLotDimensions: null,
  propertyLotFeatures: [],
  propertyWaterfrontName: null,
  propertyWaterfrontView: [],
  propertyAgriculturalWater: [],
  propertyPool: [],
  propertyTopography: [],
  propertySpecialListingConditions: [],
  propertyAssessmentPending: null,
  propertyHoaFee: null,
  propertyHoaFeeFrequency: null,
  propertyMonthlyHoaFee: null,
  propertyHoaCompanyName: null,
  propertyHoaBenefits: [],
  propertyGreenCert: null,
  propertyCommunityName: null,
  propertySharedAmenities: [],
  propertyUnitAmenities: [],
  propertySchoolDistrict: null,
  propertySchoolName: null,
  propertyRestrictions: [],
  propertyTaxHistory: [],
  propertyPriceHistory: [],
  propertyHandicapAccess: [],
  propertyRemarks: null,
  propertyPresentUse: null,
  propertySearchSpecialties: [],
  propertyPhotos: {
    small: [],
    medium: [],
    large: []
  },
  propertyCoverPhoto: null,
  propertyVirtualTours: [],
  propertyOpenHouses: [],
  propertyDetailedAppliances: [],
  propertyUserEntered: false
}



// WEBPACK FOOTER //
// ./src/store/lib/defaultValues.js